import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const WorkInProgressPage = ({
  setCurrentPage,
  goToLeaderboard,
  mobileMenuOpen,
  setMobileMenuOpen
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 via-purple-600 to-purple-800 overflow-x-hidden flex flex-col">
      <Header 
        setCurrentPage={setCurrentPage} 
        goToLeaderboard={goToLeaderboard}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />

      <div className="flex-1 pt-20 p-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 sm:mb-12 text-white px-2">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
              We are still working on this part of the website!
            </h1>
          </div>
          <div className="bg-white rounded-2xl shadow-2xl p-4 sm:p-6 md:p-8 flex justify-center">
            <img
              src="workingonit.png"
              alt="Work in Progress"
              className="max-w-full h-auto"
            />
          </div>
        </div>
      </div>
      <div className="h-32"></div>
      <Footer setCurrentPage={setCurrentPage} goToLeaderboard={goToLeaderboard} />
    </div>
  );
};

export default WorkInProgressPage;